import $ from 'jquery'

export default class Modal {
  constructor(props) {
    this.elm = document.querySelector(props.target)
  }

  init() {
    if (this.elm) {
      this.elm.addEventListener('click', (event) => {
        event.preventDefault()
        $('.c-modal').addClass('-is-modal-open')
        if ($('body').hasClass('en')) {
          $('.c-modal__container').children('iframe').attr('src', 'https://www.youtube.com/embed/iJ0w111MRqs')
        } else {
          $('.c-modal__container').children('iframe').attr('src', 'https://www.youtube.com/embed/0ZlGP8tjSto')
        }
      })
      $('.js-modal-close').on('click', (event) => {
        event.preventDefault()
        $('.c-modal').removeClass('-is-modal-open')
        $('.c-modal__container').children('iframe').attr('src', '')
      })
    }
  }
}
